import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { createDefecation } from '../thunk';

import type { DefecationInputType } from '@/domain/defecation/component/DefecationFormInput';
import type { ChildJson } from '@/types/domain/child/entities/childEntity';
import type { FacilityJson } from '@/types/domain/childApply/entities/facilityEntity';
import type { UserType } from '@/types/domain/user/redux';

import DialogTitle from '@/components/DialogTitle';
import DefecationFormInput from '@/domain/defecation/component/DefecationFormInput';
import { MeasureDateTime } from '@/domain/defecation/service/entity/valueObjects/measureDateTime';
import { parseTimeByCurrentDate } from '@/utils/date';

/**
 * プロパティ
 */
export type AddDefecationInput = {
  /** ひらくか */
  isOpen: boolean,
  /** 閉じる */
  close: () => void,
  /** ユーザー */
  user: UserType,
  /** 子ども */
  child: ChildJson,
  /** 施設リスト */
  facilityList: FacilityJson[],
  /** 日付 */
  date?: Date,
};

const AddDefecation: React.FC<AddDefecationInput> = ({
  isOpen,
  close,
  user,
  child,
  facilityList,
  date,
}) => {
  const dispatch = useDispatch();
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<DefecationInputType>({
    defaultValues: {
      isYesterday: false,
      defecationCategory: '普通',
      measureDateTime: MeasureDateTime.toStringTime(new Date(), false),
    },
  });
  const onSubmit = (input: DefecationInputType) => {
    const username = user.name;
    const dt = parseTimeByCurrentDate(input.measureDateTime, date);
    if (input.isYesterday) {
      dt.setDate(dt.getDate() - 1);
    }
    dispatch(createDefecation({
      data: {
        data: {
          measureDateTime: dt.toJSON(),
          defecationCategory: input.defecationCategory,
          measurerId: username,
          measurerType: 'app',
          parentId: username,
          childId: child.childId,
        },
        pub: {
          sendId: `${child.parentId}_${child.childId}`,
          replyId: username,
          data: {},
        },
      },
      facilityIds: facilityList.map((v) => v.data.facilityId),
    }));
    close();
  };
  return (
    <Dialog
      open={isOpen}
      onClose={() => close()}
    >
      <form
        onSubmit={handleSubmit(onSubmit)}
        style={{ minWidth: '300px' }}
      >
        <DialogTitle title="排泄の登録" />
        <DialogContent>
          <DefecationFormInput
            control={control}
            errors={errors}
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            type="submit"
            color="primary"
          >
            登録する
          </Button>
          <Button
            variant="contained"
            onClick={() => close()}
            color="primary"
          >
            閉じる
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AddDefecation;
